import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";

interface NewsCardProps {
  item: NewsItem;
}

export default function NewsCard({ item }: NewsCardProps) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-all duration-300 hover:border-primary-200 hover:bg-background-100/60 sm:flex-row"
    >
      <div className="h-44 w-full shrink-0 overflow-hidden bg-background-200 sm:h-auto sm:w-56">
        <img
          src={item.cover}
          alt={`${item.title} 配图`}
          title={`${item.title} 影视资讯图片`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex flex-wrap items-center gap-2 text-xs">
          <span className="rounded-full bg-accent-100 px-2.5 py-0.5 font-medium text-accent-900">
            {item.category}
          </span>
          <span className="text-foreground-500">{item.publishTime}</span>
          <span className="text-foreground-400">· {item.author}</span>
        </div>
        <h3 className="mt-2.5 line-clamp-2 font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {item.summary}
        </p>
        <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
          阅读全文
          <i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
}